import React from 'react';
import {flowRight, clamp} from 'lodash';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'react-recompose'. '/home/runner/work/flow-to-typescript-codemod/flow-to-typescript-codemod/webflow/node_modules/react-recompose/dist/Recompose.cjs.js' implicitly has an 'any' type.
import {withHandlers, withState, withProps, flattenProp} from 'react-recompose';
import {themeable} from '@packages/utilities/styled';
import * as UiScrollbar from './UiScrollbar';
import draggable from './logic/draggable';

const DraggableThumb = draggable(UiScrollbar.Thumb);

// @ts-expect-error - TS7031 - Binding element 'theme' implicitly has an 'any' type. | TS7031 - Binding element 'viewLength' implicitly has an 'any' type. | TS7031 - Binding element 'scrollLength' implicitly has an 'any' type.
const deriveThumbLength = withProps(({theme, viewLength, scrollLength}) => ({
  thumbLength:
    viewLength && scrollLength
      ? Math.max((viewLength * viewLength) / scrollLength, theme.control.height)
      : theme.control.height,
}));

const createScrollHandler =
  (pagePercentage: number) =>
  // @ts-expect-error - TS7031 - Binding element 'onScroll' implicitly has an 'any' type. | TS7031 - Binding element 'scrollPosition' implicitly has an 'any' type. | TS7031 - Binding element 'scrollLength' implicitly has an 'any' type.
  ({onScroll, scrollPosition, scrollLength, viewLength = 1}) =>
  (event: any) => {
    const newScrollPosition = clamp(
      scrollPosition + pagePercentage * viewLength,
      0,
      scrollLength - viewLength
    );

    if (newScrollPosition !== scrollPosition) {
      event.preventDefault();
      onScroll(newScrollPosition);
    }
  };

const provideHandlers = withHandlers({
  onTrackPrev: createScrollHandler(-0.9),
  onTrackNext: createScrollHandler(0.9),
  onDrag:
    ({
      // @ts-expect-error - TS7031 - Binding element 'onScroll' implicitly has an 'any' type.
      onScroll,
      // @ts-expect-error - TS7031 - Binding element 'scrollPosition' implicitly has an 'any' type.
      scrollPosition,
      // @ts-expect-error - TS7031 - Binding element 'scrollLength' implicitly has an 'any' type.
      scrollLength,
      // @ts-expect-error - TS7031 - Binding element 'viewLength' implicitly has an 'any' type.
      viewLength,
      // @ts-expect-error - TS7031 - Binding element 'dragStartPosition' implicitly has an 'any' type.
      dragStartPosition,
      // @ts-expect-error - TS7031 - Binding element 'thumbLength' implicitly has an 'any' type.
      thumbLength,
      // @ts-expect-error - TS7031 - Binding element 'horizontal' implicitly has an 'any' type.
      horizontal,
    }) =>
    (deltas: any) => {
      const delta = deltas[horizontal ? 'x' : 'y'];

      const newScrollPosition = clamp(
        dragStartPosition +
          (delta * scrollLength) /
            // This voodoo is to account for minimum thumb length.
            (viewLength -
              thumbLength +
              (viewLength * viewLength) / scrollLength),
        0,
        scrollLength - viewLength
      );

      if (newScrollPosition !== scrollPosition) {
        onScroll(newScrollPosition);
      }
    },
});

const enhance = flowRight(themeable, deriveThumbLength, provideHandlers);

const Scrollbar = enhance(
  ({
    // @ts-expect-error - TS7031 - Binding element 'style' implicitly has an 'any' type.
    style,
    viewLength = 1,
    // @ts-expect-error - TS7031 - Binding element 'scrolling' implicitly has an 'any' type.
    scrolling,
    // @ts-expect-error - TS7031 - Binding element 'scrollLength' implicitly has an 'any' type.
    scrollLength,
    // @ts-expect-error - TS7031 - Binding element 'scrollPosition' implicitly has an 'any' type.
    scrollPosition,
    // @ts-expect-error - TS7031 - Binding element 'hoveringTrack' implicitly has an 'any' type.
    hoveringTrack,
    // @ts-expect-error - TS7031 - Binding element 'hoveringThumb' implicitly has an 'any' type.
    hoveringThumb,
    // @ts-expect-error - TS7031 - Binding element 'horizontal' implicitly has an 'any' type.
    horizontal,
    // @ts-expect-error - TS7031 - Binding element 'thumbLength' implicitly has an 'any' type.
    thumbLength,
    // @ts-expect-error - TS7031 - Binding element 'dragging' implicitly has an 'any' type.
    dragging,
    // @ts-expect-error - TS7031 - Binding element 'onDragStart' implicitly has an 'any' type.
    onDragStart,
    // @ts-expect-error - TS7031 - Binding element 'onDrag' implicitly has an 'any' type.
    onDrag,
    // @ts-expect-error - TS7031 - Binding element 'onDragEnd' implicitly has an 'any' type.
    onDragEnd,
    // @ts-expect-error - TS7031 - Binding element 'onTrackPrev' implicitly has an 'any' type.
    onTrackPrev,
    // @ts-expect-error - TS7031 - Binding element 'onTrackNext' implicitly has an 'any' type.
    onTrackNext,
    // @ts-expect-error - TS7031 - Binding element 'onMouseMove' implicitly has an 'any' type.
    onMouseMove,
    // @ts-expect-error - TS7031 - Binding element 'onMouseLeave' implicitly has an 'any' type.
    onMouseLeave,
    // @ts-expect-error - TS7031 - Binding element 'onThumbMouseEnter' implicitly has an 'any' type.
    onThumbMouseEnter,
    // @ts-expect-error - TS7031 - Binding element 'onThumbMouseLeave' implicitly has an 'any' type.
    onThumbMouseLeave,
    // @ts-expect-error - TS7031 - Binding element 'large' implicitly has an 'any' type.
    large,
  }) => {
    if (scrollLength <= viewLength) {
      return null;
    }
    return (
      <UiScrollbar.Bar
        style={style}
        length={viewLength}
        horizontal={horizontal}
        onMouseMove={onMouseMove}
        onMouseLeave={onMouseLeave}
        large={large}
        data-legacy-ds="Scrollbar"
      >
        <UiScrollbar.Track
          dragging={dragging}
          horizontal={horizontal}
          scrolling={scrolling}
          hoveringTrack={hoveringTrack}
          length={2 * viewLength - thumbLength}
          position={
            // first check if there's a scrollable area
            scrollLength <= viewLength
              ? 0
              : // Thumb scroll position
                (scrollPosition * (viewLength - thumbLength)) /
                  (scrollLength - viewLength) -
                // remove length of TrackPiece
                (viewLength - thumbLength)
          }
        >
          <UiScrollbar.TrackPiece onMouseDown={onTrackPrev} />
          <DraggableThumb
            mode="delta"
            // @ts-expect-error - TS2769 - No overload matches this call.
            horizontal={horizontal}
            scrolling={scrolling}
            hoveringTrack={hoveringTrack}
            hoveringThumb={hoveringThumb}
            length={thumbLength}
            dragging={dragging}
            onDragStart={onDragStart}
            onDrag={onDrag}
            onDragEnd={onDragEnd}
            onMouseEnter={onThumbMouseEnter}
            onMouseLeave={onThumbMouseLeave}
            large={large}
          />
          <UiScrollbar.TrackPiece onMouseDown={onTrackNext} />
        </UiScrollbar.Track>
      </UiScrollbar.Bar>
    );
  }
);

Scrollbar.displayName = 'Scrollbar';

const initialState = {
  hoveringTrack: false,
  hoveringThumb: false,
  dragging: false,
  dragStartPosition: 0,
} as const;

const scrollbarState = flowRight(
  withState('state', 'setState', initialState),
  flattenProp('state'),
  withHandlers({
    onMouseMove:
      // @ts-expect-error - TS7031 - Binding element 'state' implicitly has an 'any' type. | TS7031 - Binding element 'setState' implicitly has an 'any' type.

      ({state, setState}) =>
        () => {
          setState({
            hoveringTrack: true,
            hoveringThumb: state.hoveringThumb,
            dragging: state.dragging,
            dragStartPosition: state.dragStartPosition,
          });
        },
    onMouseLeave:
      // @ts-expect-error - TS7031 - Binding element 'state' implicitly has an 'any' type. | TS7031 - Binding element 'setState' implicitly has an 'any' type.

      ({state, setState}) =>
        () => {
          setState({
            hoveringTrack: false,
            // Need to set false here, because onMouseLeave can fire directly after onThumbMouseLeave,
            // and state.hoveringThumb can be stale.
            hoveringThumb: false,
            dragging: state.dragging,
            dragStartPosition: state.dragStartPosition,
          });
        },
    onThumbMouseEnter:
      // @ts-expect-error - TS7031 - Binding element 'state' implicitly has an 'any' type. | TS7031 - Binding element 'setState' implicitly has an 'any' type.

      ({state, setState}) =>
        () => {
          setState({
            // Track is an ancestor of Thumb, so hovering Thumb should always hover Track
            // Setting to true here, in case the DOM structure changes in the future
            hoveringTrack: true,
            hoveringThumb: true,
            dragging: state.dragging,
            dragStartPosition: state.dragStartPosition,
          });
        },
    onThumbMouseLeave:
      // @ts-expect-error - TS7031 - Binding element 'state' implicitly has an 'any' type. | TS7031 - Binding element 'setState' implicitly has an 'any' type.

      ({state, setState}) =>
        () => {
          setState({
            hoveringTrack: state.hoveringTrack,
            hoveringThumb: false,
            dragging: state.dragging,
            dragStartPosition: state.dragStartPosition,
          });
        },
    onRest:
      // @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'scrolling' implicitly has an 'any' type. | TS7031 - Binding element 'hoveringTrack' implicitly has an 'any' type. | TS7031 - Binding element 'dragging' implicitly has an 'any' type.

      ({setState, scrolling, hoveringTrack, dragging}) =>
        () => {
          if (!scrolling && !hoveringTrack && !dragging) {
            setState(initialState);
          }
        },
    onDragStart:
      // @ts-expect-error - TS7031 - Binding element 'state' implicitly has an 'any' type. | TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'scrollPosition' implicitly has an 'any' type.

      ({state, setState, scrollPosition}) =>
        () => {
          setState({
            hoveringTrack: state.hoveringTrack,
            hoveringThumb: state.hoveringThumb,
            dragging: true,
            dragStartPosition: scrollPosition,
          });
        },
    onDragEnd:
      // @ts-expect-error - TS7031 - Binding element 'state' implicitly has an 'any' type. | TS7031 - Binding element 'setState' implicitly has an 'any' type.

      ({state, setState}) =>
        () => {
          setState({
            hoveringTrack: state.hoveringTrack,
            hoveringThumb: state.hoveringThumb,
            dragging: false,
            dragStartPosition: state.dragStartPosition,
          });
        },
  })
);

export default scrollbarState(Scrollbar);
